import { REGION } from '@env';
import { Realtime, Types } from 'ably';
import { Observable, Subject } from 'rxjs';

export class AblyClient {
  get chanels(): Types.Channels<Types.RealtimeChannelCallbacks> {
    return this._client.channels;
  }

  get auth(): Types.AuthCallbacks {
    return this._client.auth;
  }

  public connected$: Observable<Types.ConnectionStateChange>;
  public reconnected$: Observable<void>;

  public ablyCallBackUrl: string;

  private readonly _client: Realtime;

  private readonly _connected$ = new Subject<Types.ConnectionStateChange>();
  private readonly _reconnected$ = new Subject<void>();

  constructor(key: string, callback: any) {
    const clientOptions: Types.ClientOptions = {
      // log: {
      //   level: 4,
      // },
      environment: REGION.toString() === 'UK' ? 'eu' : undefined,
      token: key,
      authCallback: callback,
    };

    this._client = new Realtime(clientOptions);

    this.connected$ = this._connected$.asObservable();
    this.reconnected$ = this._reconnected$.asObservable();

    let suspended = false;

    this._client.connection.on('connected', (state: any) => {
      if (suspended) {
        suspended = false;
        this._reconnected$.next();
      }

      this._connected$.next(state);
    });

    this._client.connection.on('suspended', () => {
      suspended = true;
    });
  }

  public destroy(): void {
    this._client.close();
    this._reconnected$.complete();
  }
}
